import React from 'react';

import { Box, Typography } from '@mui/material';
import { BoxProps } from '@mui/material/Box';

import SectionTitle from './SectionTitle';

type TypeValue = 'titles' | 'subtitles' | 'menu' | 'pageLink';
type VariantValue = 'subtitle1' | 'h6' | 'body1';

interface PageLinkItemProps extends BoxProps {
  first?: string;
  second?: string;
  third?: string;
  type?: TypeValue;
  variant?: VariantValue;
  url: string;
}

const PageLinkItem: React.FC<PageLinkItemProps> = ({
  first,
  second,
  third,
  type = 'menu',
  variant,
  url,
  ...props
}) => {
  return (
    <Box
      component='a'
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      sx={{ display: 'inline-block', maxWidth: '100%', overflowWrap: 'anywhere', px: 2, py: 1 }}
      {...props}
    >
      <SectionTitle
        first={first}
        second={second}
        third={third}
        type={type}
        variant={variant}
        padding='0'
      />
      <Typography
        component='span'
        variant='caption'
        sx={{ display: 'block', color: '#475569', textTransform: 'none' }}
      >
        Opens in a new tab
      </Typography>
    </Box>
  );
};

export default PageLinkItem;
